import { graphqlApi } from '@/graphql'
import { baseApi } from '@/services'
import { Valuation } from '@/types/unlock'

export const valuationApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listValuations: builder.query<Valuation[], void>({
      query: () => `v1/valuation/`,
    }),
    getValuation: builder.query<Valuation, number>({
      query: (uuid) => `v1/valuation/${uuid}/`,
    }),
    createValuation: builder.mutation<Valuation, Partial<Valuation>>({
      query: (valuation) => ({
        method: 'POST',
        url: 'v1/valuation/',
        body: valuation,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'ValuationV2',
        'Escalations',
        'Alert',
      ],
    }),
    updateValuation: builder.mutation<Valuation, Partial<Valuation>>({
      query: (valuation) => ({
        method: 'PATCH',
        url: `v1/valuation/${valuation.uuid}/`,
        body: valuation,
      }),
      async onQueryStarted(args, { dispatch, queryFulfilled }) {
        await queryFulfilled
        dispatch(graphqlApi.util.invalidateTags(['gql:applicationValuationsCalcs']))
      },
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'ValuationV2',
        'Escalations',
        'Alert',
      ],
    }),
    deleteValuation: builder.mutation<void, string>({
      query: (valuationUUID) => ({
        method: 'DELETE',
        url: `v1/valuation/${valuationUUID}/`,
      }),
      invalidatesTags: [
        'Application',
        'ApplicationOffer',
        'AutomatedApplicationExceptions',
        'ValuationV2',
        'AtypicalityCheckCalcs',
        'ApplicationGuidelines',
        'ApplicationCalcs',
        'ValuationV2',
        'Escalations',
        'Alert',
      ],
    }),
  }),
})

export const {
  useCreateValuationMutation,
  useUpdateValuationMutation,
  useDeleteValuationMutation,
} = valuationApi
